import { render } from "./ConfigurationPassword.vue?vue&type=template&id=18a50c8e&scoped=true"
import script from "./ConfigurationPassword.vue?vue&type=script&lang=js"
export * from "./ConfigurationPassword.vue?vue&type=script&lang=js"

import "./ConfigurationPassword.vue?vue&type=style&index=0&id=18a50c8e&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a50c8e"]])

export default __exports__